
import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { useNavigate, useLocation } from 'react-router-dom';
import InteractiveBuilding from '../components/InteractiveBuilding';
import { trackPageView } from '../utils/analytics';

const Index = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    trackPageView(location.pathname, 'Wireless Modbus Ecosystem - Home');
  }, [location.pathname]);

  const navigateToProducts = () => {
    navigate('/products');
  };

  return (
    <div className="min-h-screen">
      <div className="py-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            className="text-center mb-6"
          >
            <h1 className="text-4xl sm:text-5xl text-white mb-6 font-magistral font-extrabold tracking-wide">
              Wireless Modbus Ecosystem
            </h1>
            <p className="text-lg text-white/90 max-w-3xl mx-auto">
              Room controllers, Fire dampers, Sensors... as long as they speak Modbus they can be a part of the Wireless Modbus Ecosystem. Make your device wireless with{' '}
              <a 
                href="https://lumenradio.com/wireless-modbus/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-[#a6c522] hover:underline"
              >
                W-Modbus
              </a>{' '}
              by LumenRadio and stay relevant for the future.
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.5 }}
            className="text-center mb-6"
          >
            <button
              onClick={navigateToProducts}
              className="bg-white text-background px-8 py-4 rounded-lg font-semibold text-lg
                       hover:bg-[#a7cc00] hover:text-white transition-colors duration-300
                       shadow-lg hover:shadow-xl mb-4"
            >
              Discover the Ecosystem
            </button>
            <p className="text-white/80 italic">
              "It's like a puzzle where every piece connects seamlessly"
            </p>
          </motion.div>

          <InteractiveBuilding />

          <div className="flex justify-center mt-16">
            <img 
              src="/lovable-uploads/636f788c-9850-49b6-aac1-1eccb1ba981c.png"
              alt="LumenRadio Logo"
              className="h-12 w-auto"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Index;
